import Title from "components/common/Title";
import * as React from "react";
import styled from "styled-components";

const Background = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const StyledTitle = styled(Title)`
  font-size: 45px;
  margin: 0px 0px;
  padding: 0px 0px;
`;

export interface IProps {
  className?: string;

  children: any;
}

export interface IState {
  offline: boolean;
}

export const NetworkContext = React.createContext<boolean>(false);

class NetworkGate extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      offline: false
    };
  }

  public render() {
    const { className, children } = this.props;
    const { offline } = this.state;

    return (
      <div className={className} title="ConfigLoaderGate">
        <NetworkContext.Provider value={offline}>
          {!offline && children}
          {offline && (
            <Background>
              <StyledTitle>
                It seems that your are currently offline. Please connect to the
                Internet in order to use the Leafbuyer Loyalty App
              </StyledTitle>
            </Background>
          )}
        </NetworkContext.Provider>
      </div>
    );
  }

  public componentDidMount() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.updateOnlineStatus();
  }

  public componentWillUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  }

  private updateOnlineStatus = () => {
    this.setState({
      offline: !navigator.onLine
    });
  };
}

export default NetworkGate;



// WEBPACK FOOTER //
// ./src/components/Gates/NetworkGate.tsx